import React from 'react';
import dynamic from 'next/dynamic';
import { Modal, Loader } from '@/components';

import styles from './SizeModal.module.scss';

const SizeTable = dynamic(() => import('../sizeTable'), {
	loading: () => <Loader />,
});

const Html = dynamic(() => import('../html'), {
	loading: () => <Loader />,
});

const ModalTrigger = props => {
	return (
		<button className={styles.trigger} {...props}>
			Таблица размеров
		</button>
	);
};

const SizeModal = ({ data }) => {
	const { table = {}, text } = data || {};
	if (!table && !text) return null;

	return (
		<div>
			<Modal render={ModalTrigger} isSizeTable>
				{table && (
					<>
						<h2 className={styles.title}>Таблица размеров</h2>
						<SizeTable data={table} />
					</>
				)}
				{text && (
					<div className={styles.modalHtml}>
						<Html html={text} />
					</div>
				)}
			</Modal>
		</div>
	);
};

export default SizeModal;
